import {useEffect, useRef, useState} from "react";
import {Button, Card, Form, Input, Select} from "antd";
import {t} from "i18next";
import UnitSelectbox from "../unit/UnitSelectbox";
import {useHistory, useParams} from "react-router-dom";
import SimpleLayout from "../../core/components/layout/SimpleLayout";
import ApiService from "../../core/service/ApiService";

export default function DoctorCreateEdit({})
{
    const {doctorId} = useParams();
    const [units, setUnits] = useState([])

    const formRef = useRef();
    const history = useHistory();
    const [doctor, setDoctor] = useState({});

    const getUnits = async () => {
        const res = await ApiService.Unit.GetUnitList();
        if(res.success)
        {
            setUnits(res.data)
        }
    }

    const getDoctor = async () => {
        if(doctorId)
        {
            const res = await ApiService.Doctor.GetDoctor(doctorId);

            if(res.success)
            {
                formRef.current.setFieldsValue({
                    ...res.data,
                    unitIdList: res.data.units.map(x => x.id)
                });
                setDoctor(res.data)
            }
        }
    }

    const onFinish = async (formData) => {
        if(doctorId)
        {
            const res = await ApiService.Doctor.EditDoctor(doctorId, formData);
            await getDoctor();
        }
        else
        {
            const res = await ApiService.Doctor.CreateDoctor(formData);

            if(res.success)
            {
                history.push(`/app/system/doctors/edit/${res.data}`)
            }
        }
    }

    useEffect(() => {
        getDoctor()
    }, [doctorId])

    useEffect(() => {
        getUnits()
    }, [])

    return (
        <SimpleLayout>
            <Card
                title={!doctorId ? t('New Doctor') : `${t('Edit Doctor')} - ${doctor.name}`}
            >
                <Form
                    ref={formRef}
                    layout={'vertical'}
                    onFinish={onFinish}
                >
                    <Form.Item
                        label={t('Name')}
                        name={'name'}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        label={t('Units')}
                        name={'unitIdList'}
                    >
                        <Select
                            mode={'tags'}
                        >
                            {
                                units.map(u => {
                                    return (
                                        <Select.Option value={u.id} key={u.id}>
                                            {u.name}
                                        </Select.Option>
                                    )
                                })
                            }
                        </Select>
                    </Form.Item>

                    <Form.Item>
                        <Button htmlType={'submit'} type={'primary'}>{t('Save')}</Button>
                    </Form.Item>
                </Form>
            </Card>
        </SimpleLayout>
    )
}